export const TARIFF_SERVICE_TYPES = [
  {
    value: 'NSR',
    name: 'NSR',
  },
  {
    value: 'IDD',
    name: 'IDD',
  },
  {
    value: 'ROC',
    name: 'ROC',
  },
  {
    value: 'WGD/WWA',
    name: 'WGD/WWA',
  },
];
